import { mapState, mapActions, mapMutations } from 'vuex'
import Util from '../../util/funcoes'

export default {
  data() {
    return {
      isLoading: false
    }
  },

  created() {
    this.listar();
  },

  computed: {
    ...mapState('contasPagarAtrasadasStore', {
      contasPagarAtrasadas(state) { return state.listaDeContasPagarAtrasadas }
    }),

    tooltipQuantidadeContasIsVisible() {
      return this.contasPagarAtrasadas.length > 0;
    },

    quantidadeContas() {
      const quantidade = this.contasPagarAtrasadas.length;

      switch (quantidade) {
        case 1:
          return 'Exibindo 1 lançamento.'
        default:
          return `Exibindo ${quantidade} lançamentos.`
      }
    }
  },

  methods: {
    ...mapActions('contasPagarAtrasadasStore', [
      'recuperarContasPagarAtrasadas'
    ]),

    ...mapMutations('contasPagarAtrasadasStore', [
      'limparContasPagar'
    ]),

    listar() {
      this.showLoading();
      this.limparContasPagar();
      this.recuperarContasPagarAtrasadas()
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    showLoading() {
      this.isLoading = true;
    },
    hideLoading() {
      this.isLoading = false;
    },

    formatarLabelValor(item) {
      return Util.formatarValor(item.valor);
    },
  }
}